<template>
  <div class="contaniner">
    <div class="CoalModel_box_title">
      <el-page-header @back="getReturn" content="煤矿详情"> </el-page-header>
      <div class="CoalModel_box_title_cz" @click="detailLink">调整历史</div>
    </div>
    <el-divider></el-divider>
    <div>
      <el-row :gutter="16">
        <el-col :span="6"><div>用户名：{{ coalDetail.userName }}</div></el-col>
        <el-col :span="7"><div>公司名称：{{ coalDetail.companyName }}</div></el-col>
        <el-col :span="10"><div>地址：{{ coalDetail.companyAddress }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"><div>联系电话：{{ coalDetail.contactPhone }}</div></el-col>
        <div v-if="+coalDetail.status == 0">
          <el-col :span="7"><div>审核通过时间：{{ coalDetail.updateTime }}</div></el-col>
          <el-col :span="10"><div>操作员：{{ coalDetail.updateUser }}</div></el-col>
        </div>
      </el-row>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="煤种" name="1"></el-tab-pane>
      <el-tab-pane label="煤仓" name="2"></el-tab-pane>
      <el-tab-pane label="采购计划" name="3"></el-tab-pane>
    </el-tabs>
    <component :is="tabComponents" :coalMineNo="coalMineNo">></component>
  </div>
</template>

<script>
import CoalType from "./components/CoalType";
import Bunker from "./components/Bunker";
import Particulars from "./components/Particulars";
export default {
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  components: {
    CoalType,
    Bunker,
    Particulars,
  },
  data() {
    return {
      coalDetail: {},
      activeName: "1",
      formInline: {
        user: "",
        region: "",
      },
      loading: false,
      tabComponents: "",
    };
  },
  mounted() {
    this.getCoalDetail();
    this.handleClick();
  },
  methods: {
    async getCoalDetail() {
      let res = await this.$api.coalModel.coalmineDetail({ coalMineNo: this.coalMineNo });
      this.coalDetail = res.data;
      this.loading = false;
    },
    handleClick(tab, event) {
      if (!tab) {
        this.tabComponents = CoalType;
        return;
      }
      tab.name == 1
        ? (this.tabComponents = CoalType)
        : tab.name == 2
        ? (this.tabComponents = Bunker)
        : (this.tabComponents = Particulars);
    },
    getReturn() {
      this.$emit("Adjust", false);
    },
    detailLink() {
      this.$emit("checkDetail");
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
  font-size: 14px;
}
.el-select {
  margin-right: 30px;
}
.el-table {
  width: 80%;
}
.contaniner {
  padding-bottom: 100px;
}
</style>